export enum Colors {
    Body = '#505050',
    Surface = '#FFFFFF',
    Background = '#F1F1F1',
    Primary = '#0070B0',
    PrimaryActive = '#015C97',
    PrimaryVariant = '#00497F',
    PrimaryComplete = '#71a1cc',
    SecondaryActive = '#D9D9D9',
    AccentLight = '#D9D9D9',
    AccentDark = '#707070',
    Shadow = 'rgba(80, 80, 80, 0.5)',
    Placeholder = 'rgba(80, 80, 80, 0.5)',
    LightBlueBackground = 'rgba(0, 112, 176, 0.05)',
    LightBlue = 'rgb(229, 240, 247)',
    LightShadow = 'rgba(112, 112, 112, 0.4)',
    LightBorder = '#00a0fc',
    Alert = '#D7374A',
    AlertVariant = '#8e2330',
    AlertActive = 'rgb(160, 47, 58)',

    AdminPrimary = '#3F51B5',
    AdminPrimaryVariant = '#1D2554',
    Disabled = 'rgba(0, 0, 0, 0.38)',

    GuestPrimary = '#017482',
    LightGreen = '#D6E7EA',
    GuestPrimaryVariant = '#01545D',

    Disaster = `#E6632A`,
    DisasterShadow = `#B4400E`,
    DisasterActive = `#C14915`,

    AdminWarningAlertDark = '#E0691A',
    AdminWarningAlertLight = '#FDF4E4',
    AdminInfoAlertDark = '#246FC5',
    AdminInfoAlertLight = '#ECF4FD',
}

export const HTMLBaseFontSizeInPixel: number = 10

export const FontSizeInPixel = {
    ExtraBig: 32.0,
    Big: 24.0,
    Accent: 20.0,
    Body: 16.0,
    Middle: 14.0,
    Small: 12.0,
}

export const FontSize = {
    ExtraBig: `${FontSizeInPixel.ExtraBig / HTMLBaseFontSizeInPixel}rem`,
    Big: `${FontSizeInPixel.Big / HTMLBaseFontSizeInPixel}rem`,
    Accent: `${FontSizeInPixel.Accent / HTMLBaseFontSizeInPixel}rem`,
    Body: `${FontSizeInPixel.Body / HTMLBaseFontSizeInPixel}rem`,
    Middle: `${FontSizeInPixel.Middle / HTMLBaseFontSizeInPixel}rem`,
    Small: `${FontSizeInPixel.Small / HTMLBaseFontSizeInPixel}rem`,
}

export enum LineHeight {
    Basic = '1.5',
}

// see `GlobalStyleResident`
// font-weight は必要十分なものだけimportしている
export enum FontWeights {
    // Thin = 100,
    Light = 300,
    Normal = 400, // equals `Regular`
    // Medium = 500,
    Bold = 700,
    // Black = 900,
}

export enum DisplaySizeValue {
    ResidentWidthMin = 320,
    ResidentWidthMax = 960,
    AdminWidthMin = 960,
    AdminWidthMax = 1280,
}

export const DispWidthSize = {
    MinWidth: `${DisplaySizeValue.ResidentWidthMin}px`,
    MaxWidth: `${DisplaySizeValue.ResidentWidthMax}px`,
}

export const BreakpointValues = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 769,
    xl: 1200,
}

export const BreakPoint = {
    Sp: `${BreakpointValues.md}px`,
}

export const ResidentScrollBoundary = {
    visibleTop: 200,
    visibleBottom: 114,
}

export const FontFamily = {
    ResidentDefault: '"Noto Sans JP", sans-serif',
}
